import { render, staticRenderFns } from "./TableListLivenesPerson.vue?vue&type=template&id=dcd268a0"
import script from "./TableListLivenesPerson.vue?vue&type=script&lang=js"
export * from "./TableListLivenesPerson.vue?vue&type=script&lang=js"
import style0 from "./TableListLivenesPerson.vue?vue&type=style&index=0&id=dcd268a0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcd268a0')) {
      api.createRecord('dcd268a0', component.options)
    } else {
      api.reload('dcd268a0', component.options)
    }
    module.hot.accept("./TableListLivenesPerson.vue?vue&type=template&id=dcd268a0", function () {
      api.rerender('dcd268a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHive/components/TableListLivenesPerson.vue"
export default component.exports